import { Link } from 'react-router-dom';

export default function StatsBanner() {
  const stats = [
    { value: '120万+', label: '注册用户' },
    { value: '5,000+', label: '官方资源' },
    { value: '800+', label: '签约画师' },
    { value: '99.7%', label: '用户好评' },
  ];

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-accent-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat) => (
            <div key={stat.label}>
              <div className="text-3xl md:text-4xl font-bold text-background-50 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-background-50/70 text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}